import React from 'react';
import { nuiCtx } from '../../common/initialization';

export type NuiDialogProps = {
    children: React.ReactNode;
    //TODO remove name property; component function itself could be used as a key in reframe model maybe?
    name: string;
    className?: string;
    mobileMode?: MobileMode;
    title?: React.ReactNode;
    priority?: number;
    buttons?: {};
    hideCloseButton?: boolean;
    noPad?: boolean;
    bounceLeft?: boolean;
    modalOffer?: boolean;
    onClose?: () => void;
};
export type MobileMode = 'CENTER' | 'DOCKED' | 'FULLSCREEN';

export type DialogProps = {
    close?: () => void;
};

export type Dialog<T extends DialogProps> = { name: string; component: React.FC<T> };
export const createDialog = function<T extends DialogProps>(dialog: Dialog<T>) {
    return dialog;
};

export function openDialog<T extends DialogProps>(popup: Dialog<T>, data?: T) {
    //TODO unified reframe dialog model goes here, openDialog goes out of nuiCtx
    nuiCtx.openDialog(popup, data);
}

export function closeDialog<T extends DialogProps>(popup: Dialog<T>) {
    //TODO unified reframe dialog model goes here, openDialog goes out of nuiCtx
    nuiCtx.closeDialog(popup);
}

export const MessageDialog = createDialog({
    name: 'nui/message',
    component: ({ message }: { message: string } & DialogProps) => {
        const { NuiDialog } = nuiCtx.components;
        return <NuiDialog name="nui/message">{message}</NuiDialog>;
    }
});
